import React from "react";

import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form/form-factory";

import * as S from "./styles";

import IFormPage from "../../../../interfaces/form-page";

type IProps = any & IFormPage;

const SolicitationEdit: React.FC<IProps> = ({
  dataForm,
  onSubmit,
  errorMessage,
  setData,
}) => (
  <S.Wrapper>
    <BackButtom text="Editar Dados do usuário" />
    <S.CardContent>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
        setData={setData}
        optionsExtra={{
          isRegister: true,
        }}
      />
    </S.CardContent>
  </S.Wrapper>
);

export default SolicitationEdit;
